import axios from "axios";
// import bus from "@/EventBus";

export default {
  namespaced: true,
  state: {
    cliente: {},
    clientes: []
  },
  mutations: {
    llenarCliente(state, clienteAccion) {
      state.cliente = clienteAccion;
    },
    llenarClientes(state, data) {
      state.clientes = data;
      // bus.$emit('cargarLista');
    },
  },
  actions: {
    getCliente: async function({ commit }, data_cliente) {
      let cliente = data_cliente.cliente
      let token = data_cliente.token
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      
      await axios
        .get(`cliente/query?_id=${cliente._id}`,configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarCliente", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getClientes: async function({ commit }, token) {
      let header = { Token: token };
      let configuracion = { headers: header };
      let data = null;
      
      await axios
        .get('cliente/list',configuracion)
        .then(function(response) {
          data = response.data;
          commit("llenarClientes", data);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    updateCliente: async function({ dispatch }, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      debugger
      await axios
        .put('cliente/update',{
          id: data.obj.id,
          usuario: data.usuario,
          tipo_cliente: data.obj.tipo_cliente,
          nombre: data.obj.nombre,
          apellido: data.obj.apellido,
          email: data.obj.email,
          fecha_nacimiento: data.obj.fecha_nacimiento,
          pais: data.obj.pais,
          tipo_documento: data.obj.tipo_documento,
          num_documento: data.obj.num_documento,
          doc_expedido: data.obj.doc_expedido,
          doc_vencimiento: data.obj.doc_vencimiento,
          licencia: data.obj.licencia,
          lic_expedido: data.obj.lic_expedido,
          lic_vencimiento: data.obj.lic_vencimiento,
          telefono: data.obj.telefono,
          telefono_movil: data.obj.telefono_movil,
          direccion_habitual: data.obj.direccion_habitual,
          municipio_habitual: data.obj.municipio_habitual,
          provincia_habitual: data.obj.provincia_habitual,
          reputacion: data.obj.reputacion,
          imagen: data.obj.imagen,
          observaciones: data.obj.observaciones,
        },configuracion)
        .then(function(res) {
          dispatch('getClientes', data.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue actualizado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          swal({
            title: "Algo ha salido mal",
            text: `Error de tipo ${error}`,
            icon: "error",
          }); 
        });
    },
    saveCliente: async function({dispatch}, data) {
      let header = { Token: data.token };
      let configuracion = { headers: header };
      await axios
        .post('cliente/add',{
          usuario: data.usuario,
          tipo_cliente: data.obj.tipo_cliente,
          nombre: data.obj.nombre,
          apellido: data.obj.apellido,
          email: data.obj.email,
          fecha_nacimiento: data.obj.fecha_nacimiento,
          pais: data.obj.pais,
          tipo_documento: data.obj.tipo_documento,
          num_documento: data.obj.num_documento,
          doc_expedido: data.obj.doc_expedido,
          doc_vencimiento: data.obj.doc_vencimiento,
          licencia: data.obj.licencia,
          lic_expedido: data.obj.lic_expedido,
          lic_vencimiento: data.obj.lic_vencimiento,
          telefono: data.obj.telefono,
          telefono_movil: data.obj.telefono_movil,
          direccion_habitual: data.obj.direccion_habitual,
          municipio_habitual: data.obj.municipio_habitual,
          provincia_habitual: data.obj.provincia_habitual,
          reputacion: data.obj.reputacion,
          imagen: data.obj.imagen,
          observaciones: data.obj.observaciones,
        },configuracion)
        .then(function(res) {
          dispatch('getClientes', data.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue agregado exitosamente`,
            icon: "success",
          }); 
        })
        .catch(function(error) {
          swal({
            title: "Algo ha salido mal",
            text: `Error de tipo ${error}`,
            icon: "error",
          }); 
        });
    },
    activateCliente: async function({ dispatch }, data_cliente) {
      let header = { Token: data_cliente.token };
      let configuracion = { headers: header };
      await axios
        .put('cliente/activate',{_id: data_cliente.id,},configuracion)
        .then(function(res) {
          dispatch('getClientes', data_cliente.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue activado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deactivateCliente: async function({ dispatch }, data_cliente) {
      let header = { Token: data_cliente.token };
      let configuracion = { headers: header };
      await axios
        .put('cliente/deactivate',{_id: data_cliente.id,},configuracion)
        .then(function(res) {
          dispatch('getClientes', data_cliente.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente ${res.data.nombre} ${res.data.apellido} fue desactivado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    deleteCliente: async function({ dispatch }, data) {
      let token = data.token
      let header = { Token: token };
      let configuracion = { headers: header };
      
      await axios
        .delete(`cliente/remove?id=${data.id}`,configuracion)
        .then(function() {
          dispatch('getClientes', data.token)
          swal({
            title: "Buen trabajo!",
            text: `El cliente fue eliminado correctamente`,
            icon: "success",
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  }
};
